var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-chart"},[_c('div',{staticClass:"line-title"},[_c('span',[_vm._v(_vm._s(_vm.$t("largesrceen.maliciousAddressTransferTrend")))])]),_c('div',{attrs:{"id":"main1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }